export type Beacon = (...args: any[]) => void;

// the window.Beacon object can change, so need to fetch
// it each time its used
export function getBeacon() {
  //@ts-ignore
  return window.Beacon;
}

